module.exports = __webpack_public_path__ + "static/img/shop-closed.bf5cc28b.png";